// extracted by mini-css-extract-plugin
export var alignLeft = "Navbar-module--align-left--288bd";
export var alignRight = "Navbar-module--align-right--c1bfe";
export var contact = "Navbar-module--contact--e6d64";
export var container = "Navbar-module--container--979f4";
export var home = "Navbar-module--home--6ea3e";
export var layout = "Navbar-module--layout--2b441";
export var linkBtn = "Navbar-module--link-btn--75d8b";
export var projects = "Navbar-module--projects--bfc95";